import { IKnm248 } from 'APIPackage/KnmModule/interfaces/IKnm248';
import { deleteObjectProperties } from 'CorePackage/MainModule/common/deleteObjectProperties';
import { convertKnmDocumentAttachmentsFormValuesToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';
import { convertFormDateValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateValueToKnmDataDate';

import { IKnmErknmForm } from '../interfaces/IKnmErknmForm';

export const convertReasonDocumentsFormValueToKnmData = (values: IKnmErknmForm): IKnm248['reasonDocuments'] => {
  const { reasonDocuments } = values;

  if (!reasonDocuments) {
    return null;
  }

  return reasonDocuments.map(item => ({
    active: item?.active || null,
    attachments: convertKnmDocumentAttachmentsFormValuesToKnmData(item?.attachments),
    videoFixations:
      item?.violationEvidences?.map(evi => ({
        guid: evi.guid || null,
        dateVideo: convertFormDateValueToKnmDataDate(evi.date),
        descVideo: evi.description,
        linkVideo: evi.link,
        originPassportId: evi.originPassportId,
      })) || null,
    correlationToken: item?.correlationToken || null,
    description: item?.description || null,
    guid: item?.guid || null,
    type: item?.type ? deleteObjectProperties(item.type, ['label', 'value']) : null,
  }));
};
